import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PermissionsService } from '../permissions.service';
import { ResponsePermissionsInterface } from '../interfaces/response-permissions.interface';
import { catchError } from 'rxjs/operators';

export const PermissionsResolver: ResolveFn<ResponsePermissionsInterface> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  permissionsService: PermissionsService = inject(PermissionsService)
): Observable<ResponsePermissionsInterface> =>
  permissionsService.fetchPermissions().pipe(
    catchError(error => {
      console.error('Permissions fetch error:', error);

      // Якщо вже на сторінці settings, не робимо редирект щоб уникнути нескінченного циклу
      if (state.url.includes('/settings')) {
        // Повертаємо порожні permissions для collaborator з NO_ACCESS статусом
        return of({
          role: 'SHOP_COLLABORATOR',
          permissions: null,
          status: 'NO_ACCESS'
        } as ResponsePermissionsInterface);
      }

      // Для інших сторінок робимо редирект на settings
      router.navigate(['/settings']);
      return of({
        role: 'SHOP_COLLABORATOR',
        permissions: null,
        status: 'NO_ACCESS'
      } as ResponsePermissionsInterface);
    })
  );
